/* =============================================
   SLIM SEARCH PREDICTIVE — Prote, Inc.
   ============================================= */
(function () {
  function formatPrice(cents) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency', currency: 'MXN', minimumFractionDigits: 0
    }).format(cents);
  }

  async function fetchPredictive(query) {
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      return data?.resources?.results?.products || [];
    } catch { return []; }
  }

  function initSearch({ formId, inputId, dropdownId, popularId, resultsId, resultsListId, emptyId, viewAllId, clearId }) {
    const form        = document.getElementById(formId);
    const input       = document.getElementById(inputId);
    const dropdown    = document.getElementById(dropdownId);
    const popular     = document.getElementById(popularId);
    const results     = document.getElementById(resultsId);
    const resultsList = document.getElementById(resultsListId);
    const emptyEl     = document.getElementById(emptyId);
    const viewAll     = document.getElementById(viewAllId);
    const clearBtn    = clearId ? document.getElementById(clearId) : null;

    if (!form || !input || !dropdown) return;

    let timer = null;

    function openDropdown()  { dropdown.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
    function closeDropdown() { dropdown.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); }
    function showPopular()   { if (popular) popular.hidden = false; if (results) results.hidden = true; if (emptyEl) emptyEl.hidden = true; }
    function showResults()   { if (popular) popular.hidden = true; if (results) results.hidden = false; if (emptyEl) emptyEl.hidden = true; }
    function showEmpty()     { if (popular) popular.hidden = true; if (results) results.hidden = true; if (emptyEl) emptyEl.hidden = false; }

    function renderResults(items) {
      if (!resultsList) return;
      resultsList.innerHTML = '';
      items.forEach(item => {
        const img = item.featured_image?.url
          ? `<img src="${item.featured_image.url}&width=140" alt="${item.title}" loading="lazy">`
          : `<div style="width:70px;height:70px;background:#f0f0f0;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:22px;">📦</div>`;
        const price = item.price_min ? formatPrice(item.price_min) : '';
        const li = document.createElement('li');
        li.className = 'slim-search__result-item';
        li.innerHTML = `<a href="${item.url}">${img}<span class="slim-search__result-title">${item.title}</span>${price ? `<span class="slim-search__result-price">${price}</span>` : ''}</a>`;
        resultsList.appendChild(li);
      });
    }

    input.addEventListener('input', function () {
      const q = this.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length === 0) { showPopular(); openDropdown(); return; }
      if (q.length < 2) return;
      timer = setTimeout(async () => {
        const products = await fetchPredictive(q);
        if (viewAll) viewAll.href = `/search?type=product&q=${encodeURIComponent(q)}`;
        if (products.length > 0) { renderResults(products); showResults(); }
        else { showEmpty(); }
        openDropdown();
      }, 280);
    });

    input.addEventListener('focus', function () {
      if (this.value.trim().length === 0) showPopular();
      openDropdown();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        this.hidden = true;
        showPopular();
        openDropdown();
        input.focus();
      });
    }

    form.querySelectorAll('.slim-search__tag').forEach(tag => {
      tag.addEventListener('click', function () {
        input.value = this.dataset.query;
        if (clearBtn) clearBtn.hidden = false;
        input.dispatchEvent(new Event('input'));
      });
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) closeDropdown();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDropdown(); input.blur(); }
    });
  }

  // Móvil
  initSearch({
    formId: 'slim-search-form-mobile',
    inputId: 'slim-search-input-mobile',
    dropdownId: 'slim-search-dropdown-mobile',
    popularId: 'slim-popular-mobile',
    resultsId: 'slim-results-mobile',
    resultsListId: 'slim-results-list-mobile',
    emptyId: 'slim-empty-mobile',
    viewAllId: 'slim-view-all-mobile',
    clearId: null
  });
})();
